let preventDeletePopupPromise = null

// Returns a Promise that resolves to true if the user confirms (textSave),
// and to false if the user cancels.
export function displayPreventDeletePopup(vm) {
    if (preventDeletePopupPromise) {
        return preventDeletePopupPromise
    }

    vm.$popup.close()

    preventDeletePopupPromise = new Promise((resolve) => {
        const finish = (confirmed) => {
            if (!preventDeletePopupPromise) {
                return
            }
            preventDeletePopupPromise = null
            vm.$popup.close()
            resolve(confirmed)
        }

        vm.$popup.confirm({
            title: vm.$t('popup.prevent_delete_response.title'),
            message: vm.$t('popup.prevent_delete_response.message'),
            type: 'simple-confirm',
            textSave: vm.$t('popup.prevent_delete_response.text_save'),
            callSave: () => {
                finish(true)
            },
            callCancel: () => {
                finish(false)
            }
        })
    })

    return preventDeletePopupPromise
}
